import { flow, types } from 'mobx-state-tree'
import { addProcessingEntityMappingReq } from '../../network/addProcessingEntityReq'
import { getProcessingEntity } from '../../network/getProcessingEntity'
import { updateProcessingEntityMappingReq } from '../../network/updateProcessingEntityMappingReq'
import { getErrorMessage, MessageTypes } from '../../utils'
import { integrationMethods } from '../../utils/constants'
import { RootStore } from '../store'

const Entity = types.model('Entity', {
  processingEntityId: types.optional(types.string, ''),
  credentials: types.optional(types.string, ''),
  endpoint: types.optional(types.string, ''),
  integrationMethod: types.optional(types.number, -1),
  name: types.optional(types.string, ''),
})
const ProcessingEntity = types
  .model('ProcessingEntity', {
    entity: types.array(Entity),
  })
  .actions((self) => ({
    getAll: flow(function* getAll() {
      try {
        const response = yield getProcessingEntity(RootStore.session.getTokens)
        const own = self
        own.entity = response?.processingEntity
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    addProcessingEntity: flow(function* addProcessingEntity(data: any) {
      try {
        const response = yield addProcessingEntityMappingReq(data, RootStore.session.getTokens)
        RootStore.message.setMessage('Update Success', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    updateProcessingEntity: flow(function* updateProcessingEntity(data: any) {
      try {
        const response = yield updateProcessingEntityMappingReq(data, RootStore.session.getTokens)
        RootStore.message.setMessage('Update Success', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getEntityList(listData: any, keys?: any, searchText?: any) {
      const list = listData ?? self.entity ?? []
      const data = list?.map((item) => {
        return {
          ID: '' + item?.processingEntityId,
          credentials: item?.credentials,
          endpoint: item?.endpoint,
          integrationMethod: integrationMethods?.find((obj) => obj.id === item.integrationMethod)?.value ?? 'NA',
          name: '' + item?.name,
          id: '' + item?.processingEntityId,
          ...item,
        }
      })
      if (keys?.length > 0) {
        if (data.length > 0) {
          if (keys && keys?.length > 0) {
            const retArr: any = []
            data.map((item: any) => {
              let isMatching = true
              keys.map((obj: any) => {
                const val = isNaN(item[obj?.key]) ? item[obj?.key]?.toLowerCase() : item[obj?.key]?.toString()
                isMatching = isMatching && val?.includes(obj?.searchString?.toLowerCase())
              })
              isMatching && retArr.push(item)
              return retArr
            })
            return retArr
          } else {
            return list?.filter((obj: any) =>
              Object.keys(obj).some((key) => obj[key].toLowerCase().includes(searchText.toLowerCase())),
            )
          }
        }
      } else {
        return data
      }
    },
    getEntity(id: any) {
      const getIntegrationId = (id: number) => {
        return integrationMethods?.find((item) => item.id === id)?.value
      }
      const item = self.entity?.find((item) => item.processingEntityId === id)
      const data = {
        processingEntityId: item?.processingEntityId ?? '',
        credentials: item?.credentials,
        endpoint: '' + item?.endpoint,
        integrationMethod: getIntegrationId(item?.integrationMethod),
        name: '' + item?.name,
      }
      return data
    },
    getProcessingEntityListForSourceAccount() {
      const data = self.entity?.map((item) => {
        return {
          id: '' + item?.processingEntityId,
          value: '' + item?.name,
        }
      })
      return data
    },
    getFilteredProcessingEntityList(listData: any, keys?: any, searchText?: any) {
      const list = listData ?? self?.entity ?? []
      const data = list?.map((item: any) => {
        return {
          ...item,
          id: `${item.id}`,
        }
      })
      if (keys?.length > 0) {
        if (data.length > 0) {
          if (keys && keys?.length > 0) {
            const retArr: any = []
            data.map((item: any) => {
              let isMatching = true
              keys.map((obj: any) => {
                const val = isNaN(item[obj?.key]) ? item[obj?.key].toLowerCase() : item[obj?.key]?.toString()
                isMatching = isMatching && val.includes(obj?.searchString.toLowerCase())
              })
              isMatching && retArr.push(item)
              return retArr
            })
            return retArr
          } else {
            return list?.filter((obj: any) =>
              Object.keys(obj).some((key) => obj[key].toLowerCase().includes(searchText.toLowerCase())),
            )
          }
        }
      }
      return data
    },
  }))

const processingEntityData = ProcessingEntity.create({
  entity: [],
})

export { ProcessingEntity, processingEntityData }
